"use client";

import { useEffect, useRef, useState } from "react";

// "Book Now" CTA: a button that reveals the Table Space App store links
// (iOS + Android), mirroring the live enterprise page.
export function BookNow({ ios, android }: { ios: string; android: string }) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const onClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    const onKey = (e: KeyboardEvent) => e.key === "Escape" && setOpen(false);
    document.addEventListener("mousedown", onClick);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onClick);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  return (
    <div ref={ref} className="relative">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        aria-haspopup="true"
        className="btn btn-primary btn-sm"
      >
        Book Now
        <span
          aria-hidden
          className={`ml-1 transition-transform duration-300 ${open ? "rotate-180" : ""}`}
        >
          ▾
        </span>
      </button>

      {open && (
        <div className="absolute left-0 top-full z-20 mt-3 flex w-60 flex-col gap-2 rounded-2xl border border-brand-line bg-brand-paper p-3 shadow-lg">
          <p className="mono-meta px-1 pb-1 text-brand-muted">
            GET THE TABLE SPACE APP
          </p>
          <a
            href={ios}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 rounded-xl border border-brand-line px-4 py-3 text-sm font-medium text-brand-ink transition-colors hover:border-brand-accent hover:text-brand-accent-dark"
          >
            <span aria-hidden className="text-lg"></span>
            <span>
              Download on the
              <span className="block text-base font-semibold">App Store</span>
            </span>
          </a>
          <a
            href={android}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 rounded-xl border border-brand-line px-4 py-3 text-sm font-medium text-brand-ink transition-colors hover:border-brand-accent hover:text-brand-accent-dark"
          >
            <span aria-hidden className="text-lg">▶</span>
            <span>
              Get it on
              <span className="block text-base font-semibold">Google Play</span>
            </span>
          </a>
        </div>
      )}
    </div>
  );
}
